import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EmissionSource } from "../../interfaces/EmissionSource";

const emissionSourceUpdated: boolean = false;

const selectedEmissionSources: any = [];

// Poluente selecionado no menu para filtrar marcadores no mapa
const selectedPollutantFilter: string = "";

const emissionSourceSlice = createSlice({
  name: "emissionSource",
  initialState: { emissionSourceUpdated, selectedEmissionSources, selectedPollutantFilter },
  reducers: {
    setEmissionSourceUpdated: (state, action: PayloadAction<boolean>) => {
      state.emissionSourceUpdated = action.payload;
    },
    setSelectedEmissionSources: (state, action: PayloadAction<any>) => {
      state.selectedEmissionSources = action.payload;
    },
    setSelectedPollutantFilter: (state, action: PayloadAction<string>) => {
      state.selectedPollutantFilter = action.payload;
    },
  },
});

export const { setEmissionSourceUpdated, setSelectedEmissionSources, setSelectedPollutantFilter } =
  emissionSourceSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state

export default emissionSourceSlice.reducer;
